import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "@/utils/classNames";

/** Proxy for "more than ~5 lines" — mirrors the v33 mockup's clamp heuristic. */
const CLAMP_THRESHOLD = 280;

/**
 * Plain "Summary" text block shown as the first element of the lead Overview
 * tab (v33 mockup `lp-overview-tab`): no border/box, clamped to 5 lines with a
 * "Read more" toggle when long. Replaces the old collapsible "About {person}"
 * element.
 */
export const PersonSummary: FunctionComponent<{
	text?: string | null;
}> = ({ text }) => {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(false);

	if (!text?.trim()) {
		return null;
	}

	const isLong = text.length > CLAMP_THRESHOLD;

	return (
		<div className="flex flex-col items-start">
			<div className="mb-1.5 text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
				{t("contacts.leadPanel.identity.summary")}
			</div>
			<div
				className={classNames(
					"whitespace-pre-line text-[13px] leading-5 text-text",
					isLong && !expanded ? "line-clamp-5" : ""
				)}
			>
				{text}
			</div>
			{isLong && (
				<button
					className="mt-1.5 cursor-pointer text-xs font-semibold text-blue-action"
					type="button"
					onClick={() => setExpanded((value) => !value)}
				>
					{expanded
						? t("contacts.leadPanel.identity.showLess")
						: t("contacts.leadPanel.identity.readMore")}
				</button>
			)}
		</div>
	);
};
